import type { Conversation } from '@/lib/api';

/**
 * A conversa está fixada no topo? Pela presença da data, e não por `!== null`:
 * o frontend sobe sozinho, e um backend anterior à fixação não manda o campo —
 * aí nada está fixado, em vez de tudo.
 */
export function isPinned(conversation: Conversation): boolean {
  return Boolean(conversation.pinnedAt);
}
